import React from "react";

const App = () => {
  const baseUrl =
    process.env.REACT_APP_IFRAME_BASE_URL || "https://default-url.com";
  const pathSegments = window.location.pathname.split("/");
  const prettyName = pathSegments.pop() || "default";

  const iframeSrc = `${baseUrl}${prettyName}`;

  return (
    <div style={{ 
      width: "100vw",
      height: "100vh",
      overflow: "hidden",
      cursor: "default",  
      pointerEvents: "none" 
    }}>
      <iframe
        src={iframeSrc}
        style={{ width: "100%", height: "100%", border: "none", cursor: "auto", pointerEvents: "auto" }}
        title="Dynamic Iframe"
        allow="geolocation *;"
      ></iframe>
    </div>
  );
};

export default App;
